import React from "react";
import "../../../src/assets/styles/scss/style.scss";

const Loading = () => {
  return (
    <div className="pt-3 text-center">
      <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
  );
};

export default Loading;
